<template>
  <div class="fullscreen-button" @click="toggleFullScreen">
    <div class="fix-menu-icon" v-if="!isFullscreen">
      <img :src="require('@/assets/image/nav/icon-d.png')" alt="">
    </div>
    <div class="fix-menu-icon" v-else>
      <img :src="require('@/assets/image/nav/icon-x.png')" alt="">
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'


export default {
  name: 'FullScreen',
  components: {
  },
  setup() {
    const isFullscreen = ref(false)

    const toggleFullScreen = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
      }
    }

    const handleFullscreenChange = () => {
      isFullscreen.value = !!document.fullscreenElement
    }

    onMounted(() => {
      document.addEventListener('fullscreenchange', handleFullscreenChange)
    })

    onUnmounted(() => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
    })

    return {
      isFullscreen,
      toggleFullScreen
    }
  }
}
</script>

<style lang="less" scoped>
.fullscreen-button {
  cursor: pointer;
  font-size: 18px;
  padding-right: 24px;
  display: flex;
  align-items: center;
  color: #666;

  &:hover {
    color: #1890ff;
  }
}

.fix-menu-icon {
  width: 18px;
  height: 18px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>